'use strict';
const mmWidgets = require('../widgets/mm-widgets');
require('./show-error');
require('./section-handler-widget');
require('./show-progress-message');

mmWidgets.fn.useGoogleEmailWidget = function (googleAuthenticator) {
	return mmWidgets.each(this, function () {
		const widget = this,
			button = widget.find('[data-mm-role~="use-google-email"]');

		button.click((e) => {
			const successSection = e.target.getAttribute('data-mm-success-section');
			widget.showProgressMessage('Retrieving GMail address');
			googleAuthenticator.getEmailAddress()
			.then(() => widget.showSection(successSection))
			.catch((reason) => widget.showError(reason));
		});
	});
};
